import { FC, useCallback } from 'react';
import { format } from 'date-fns';
import { DeviceInRolloutAttributes } from 'models/rollout';
import * as routes from 'router/Routes';
import { useNavigate } from 'react-router';
import { useAppDispatch } from 'hooks/redux';
import { fetchDeviceDetails } from 'store';
import IconCircle from 'components/UI/IconCircle';
import SortableTable from 'components/UI/Table/SortableTable';

const headerCells = [
  {
    title: 'connectivity.iprId',
    sortable: true,
  },
  {
    title: 'rollout.modified_date',
    sortable: true,
  },
  {
    title: 'rollout.software_update_status',
    sortable: true,
  },
];

export type TableDevicesInRollout = {
  iprId: string;
  lastModifiedAt: string;
  detailStatus: string;
  link: string;
};

type RolloutDeviceTableProps = {
  devices: {
    data: DeviceInRolloutAttributes[];
    isLoading: boolean;
    totalCount: number;
  };
};

const RolloutDeviceTable: FC<RolloutDeviceTableProps> = ({ devices }) => {
  // State
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  // Fetch device and navigate
  const onClick = useCallback(
    (iprId: string) => {
      if (iprId) {
        dispatch(fetchDeviceDetails(iprId));
      }
      navigate(`${routes.DEVICES}/${iprId}`);
    },
    [dispatch, navigate]
  );

  const bodyRows = devices.data.map((device: DeviceInRolloutAttributes) => {
    const { iprId, lastModifiedAt, detailStatus } = device;
    const rolloutTableItem = {
      iprId: iprId || '–',
      lastModifiedAt: lastModifiedAt
        ? format(Number(lastModifiedAt), 'yyyy-MM-dd HH:mm:ss')
        : '-',
      detailStatus: detailStatus ? (
        <IconCircle size="16px" text={detailStatus} status={detailStatus} />
      ) : (
        '–'
      ),
      link: iprId,
    };
    return rolloutTableItem;
  });

  return (
    <SortableTable
      headerCells={headerCells}
      bodyRows={bodyRows}
      onClick={onClick}
    />
  );
};

export default RolloutDeviceTable;
